import { User } from '@ih/app/shared/apis/interfaces';

export class SetUserAction {
  public static readonly type = '[User] SetUserAction';
  constructor(public readonly user: User) {}
}
